import { API_PATH } from './ApiPath'

let BUCKET
export const ACCESS_KEYID = 'AKIAQXRIUSCIQS3JLXOQ'
export const SECRET_ACCESS_KEY = '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'


if (API_PATH === 'https://api.orion22.com/api/v1' ){
    BUCKET = 'orion-private-bucket-files'
} else if (API_PATH === 'https://uniservedapi.orion22.com/api/v1' ){
    BUCKET = 'matrix-private-bucket-files'
} else if (API_PATH === 'https://stagingapi.orion22.com/api/v1'){
    BUCKET = 'test-bucket-private-classy'
} else if (API_PATH === 'http://127.0.0.1:8000/api/v1'){
    BUCKET = 'test-bucket-private-classy'
}else{
    BUCKET = 'test-bucket-private-classy'
}

export const BUCKET_NAME = BUCKET
